import { style, animate, trigger, transition, state } from '@angular/animations';


export const animations = [
    trigger('fadeIn',[
    state('void', style({
      opacity: 0, zIndex: 99
    })),
    transition(':enter', [
      animate(900, style({
          opacity: 1, zIndex: 99
      }))
    ])
  ]),
  trigger('fadeInLeft',[
    state('void', style({
      transform: 'translateX(-100%)',
      opacity: 0
    })),
    transition(':enter', [
      animate(800, style({
          transform: 'translateX(0)',
          opacity: 1
      }))
    ])
  ]),
  trigger('fadeInUp',[
      state('void', style({
        transform: 'translateY(100%)',
        opacity: 0
      })),
      transition('* => *', [
        animate(500, style({
          transform: 'translateY(0)',
          opacity: 1
        }))
      ])
    ])
];